// import React, { useState } from "react";
// import "./SideFilter.css";
// import { Accordion, Form } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faAngleRight,
//   faStar,
//   faXmark,
// } from "@fortawesome/free-solid-svg-icons";
// import { Tabs, Tab } from "react-bootstrap";
// import ReactSlider from "react-slider";
// import { useDispatch, useSelector } from "react-redux";
// import { setDoctorFilter } from "../../../features/doctor/doctorSlice";
// import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";

// const SideFilter = ({ extraFunction, category, showCloseIcon }) => {
//   const filters = useSelector((state) => state.doctor.filters);
//   const [activeKey, setActiveKey] = useState("0");
//   const [activeSize, setActiveSize] = useState("4X6");
//   const price = [filters.min_price, filters.max_price];

//   const dispatch = useDispatch();

//   const genderOptions = [
//     { id: 1, label: "Male Doctor" },
//     { id: 2, label: "Female Doctor" },
//     { id: 3, label: "Other" },
//   ];

//   return (
//     <section className="Filter_By">
//       <div className="filter_section product-by-category">
//         <p className="section_title">Subcategories</p>
//         <div className="">
//           {category?.length > 0 &&
//             category?.map((cat, index) => {
//               return (
//                 <Accordion
//                   key={cat.id}
//                   activeKey={activeKey}
//                   onSelect={(e) => setActiveKey(e)}
//                 >
//                   <Accordion.Item eventKey={String(index)}>
//                     <Accordion.Header className="acc_header">
//                       <p className="inner_text">{cat.name}</p>
//                     </Accordion.Header>

//                     <Accordion.Body>
//                       {cat?.Specializations?.length > 0 ? (
//                         cat?.Specializations.map((sub) => (
//                           <Form.Check
//                             key={sub.id}
//                             type="checkbox"
//                             label={sub.name}
//                             className="custom_checkbox"
//                             checked={(filters.specialization_id || []).includes(
//                               sub.id,
//                             )}
//                             onChange={(e) => {
//                               const currentIds =
//                                 filters.specialization_id || [];

//                               const updatedIds = e.target.checked
//                                 ? [...currentIds, sub.id]
//                                 : currentIds.filter((id) => id !== sub.id);

//                               dispatch(
//                                 setDoctorFilter({
//                                   specialization_id: updatedIds,
//                                 }),
//                               );
//                             }}
//                           />
//                         ))
//                       ) : (
//                         <p className="list_text">No Data Found</p>
//                       )}
//                     </Accordion.Body>
//                   </Accordion.Item>
//                 </Accordion>
//               );
//             })}
//         </div>


       
//       </div>

//       {/* Products by Category */}

//       <div className="filter_section product-by-category">
//         <p className="section_title">Consultation Fees</p>
//         <div className="price-range-wrapper">
//           <div className="price-values">
//             <span>₹{price[0]}</span>
//             <span>₹{price[1]}</span>
//           </div>

//           <div className="slider">
//             <ReactSlider
//               className="price-slider"
//               thumbClassName="price-thumb"
//               trackClassName="price-track"
//               value={price}
//               min={0}
//               max={filters?.fees_max}
//               step={10}
//               onChange={(value) => {
//                 dispatch(
//                   setDoctorFilter({
//                     min_price: value[0],
//                     max_price: value[1],
//                   }),
//                 );
//               }}
//             />
//           </div>
//         </div>
//       </div>
//       <div className="filter_section product-by-category">
//         <p className="section_title">Ratings</p>

//         <div className="all_checkbox">
//           {[5, 4, 3, 2, 1].map((rating) => (
//             <Form.Check
//               key={rating}
//               type="checkbox"
//               className="custom_checkbox"
//               label={
//                 <>
//                   {rating}{" "}
//                   <FontAwesomeIcon className="star-icon" icon={faStar} />
//                 </>
//               }
//               checked={(filters.rating_ids || []).includes(rating)}
//               onChange={(e) => {
//                 const currentRatings = filters.rating_ids || [];

//                 const updatedRatings = e.target.checked
//                   ? [...currentRatings, rating]
//                   : currentRatings.filter((id) => id !== rating);

//                 dispatch(
//                   setDoctorFilter({
//                     rating_ids: updatedRatings,
//                   }),
//                 );
//               }}
//             />
//           ))}
//         </div>
//       </div>
//       <div className="filter_section product-by-category">
//         <p className="section_title">Gender</p>

//         <div className="all_checkbox">
//           {genderOptions.map((gender) => (
//             <Form.Check
//               key={gender.id}
//               type="checkbox"
//               label={gender.label}
//               className="custom_checkbox"
//               checked={(filters.gender_ids || []).includes(gender.id)}
//               onChange={(e) => {
//                 const currentGender = filters.gender_ids || [];

//                 const updatedGender = e.target.checked
//                   ? [...currentGender, gender.id]
//                   : currentGender.filter((id) => id !== gender.id);

//                 dispatch(
//                   setDoctorFilter({
//                     gender_ids: updatedGender,
//                   }),
//                 );
//               }}
//             />
//           ))}
//         </div>
//       </div>

//          <Green_btn
//           btnText={ "Reset"}
        
//         />
//     </section>
//   );
// };

// export default SideFilter;


import React, { useState } from "react";
import "./SideFilter.css";
import { Accordion, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faStar,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import ReactSlider from "react-slider";
import { useDispatch, useSelector } from "react-redux";
import { setDoctorFilter } from "../../../features/doctor/doctorSlice";

const SideFilter = ({ extraFunction, category, showCloseIcon }) => {
  const filters = useSelector((state) => state.doctor.filters);


  const [activeKey, setActiveKey] = useState("0");
  const [activeSize, setActiveSize] = useState("4X6");


  const dispatch = useDispatch();


  const minPrice = filters?.min_price ?? 0;
  const maxPrice = filters?.max_price ?? filters?.fees_max ?? 0;


  const price = [minPrice, maxPrice];


  const genderOptions = [
    { id: 1, label: "Male Doctor" },
    { id: 2, label: "Female Doctor" },
    { id: 3, label: "Other" },
  ];


  return (
    <section className="Filter_By">
      <div className="filter_section product-by-category">
        <p className="section_title">Subcategories</p>


        <div>
          {category?.length > 0 &&
            category.map((cat, index) => {
              return (
                <Accordion
                  key={cat.id}
                  activeKey={activeKey}
                  onSelect={(e) => setActiveKey(e)}
                >
                  <Accordion.Item eventKey={String(index)}>
                    <Accordion.Header className="acc_header">
                      <p className="inner_text">{cat.name}</p>
                    </Accordion.Header>


                    <Accordion.Body>
                      {cat?.Specializations?.length > 0 ? (
                        cat.Specializations.map((sub) => (
                          <Form.Check
                            key={sub.id}
                            type="checkbox"
                            label={sub.name}
                            className="custom_checkbox"
                            checked={(
                              filters?.specialization_id || []
                            ).includes(sub.id)}
                            onChange={(e) => {
                              const currentIds =
                                filters?.specialization_id || [];


                              const updatedIds = e.target.checked
                                ? [...currentIds, sub.id]
                                : currentIds.filter(
                                    (id) => id !== sub.id,
                                  );


                              dispatch(
                                setDoctorFilter({
                                  specialization_id: updatedIds,
                                }),
                              );
                            }}
                          />
                        ))
                      ) : (
                        <p className="list_text">No Data Found</p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              );
            })}
        </div>
      </div>


      <div className="filter_section product-by-category">
        <p className="section_title">Consultation Fees</p>


        <div className="price-range-wrapper">
          <div className="price-values">
            <span>₹{price[0]}</span>
            <span>₹{price[1]}</span>
          </div>


          <div className="slider">
            <ReactSlider
              className="price-slider"
              thumbClassName="price-thumb"
              trackClassName="price-track"
              value={price}
              min={filters?.fees_min ?? 0}
              max={filters?.fees_max ?? 0}
              step={10}
              onChange={(value) => {
                dispatch(
                  setDoctorFilter({
                    min_price: value[0],
                    max_price: value[1],
                  }),
                );
              }}
            />
          </div>
        </div>
      </div>


      <div className="filter_section product-by-category">
        <p className="section_title">Ratings</p>


        <div className="all_checkbox">
          {[5, 4, 3, 2, 1].map((rating) => (
            <Form.Check
              key={rating}
              type="checkbox"
              className="custom_checkbox"
              label={
                <>
                  {rating}{" "}
                  <FontAwesomeIcon
                    className="star-icon"
                    icon={faStar}
                  />
                </>
              }
              checked={(filters?.rating_ids || []).includes(rating)}
              onChange={(e) => {
                const currentRatings = filters?.rating_ids || [];


                const updatedRatings = e.target.checked
                  ? [...currentRatings, rating]
                  : currentRatings.filter((id) => id !== rating);


                dispatch(
                  setDoctorFilter({
                    rating_ids: updatedRatings,
                  }),
                );
              }}
            />
          ))}
        </div>
      </div>


      <div className="filter_section product-by-category">
        <p className="section_title">Gender</p>


        <div className="all_checkbox">
          {genderOptions.map((gender) => (
            <Form.Check
              key={gender.id}
              type="checkbox"
              label={gender.label}
              className="custom_checkbox"
              checked={(filters?.gender_ids || []).includes(gender.id)}
              onChange={(e) => {
                const currentGender = filters?.gender_ids || [];


                const updatedGender = e.target.checked
                  ? [...currentGender, gender.id]
                  : currentGender.filter(
                      (id) => id !== gender.id,
                    );


                dispatch(
                  setDoctorFilter({
                    gender_ids: updatedGender,
                  }),
                );
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};


export default SideFilter;
